const TOKEN_KEY = "token";
const ROLE_KEY = "userRole";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

/** `superadmin` | `admin` | `customer` — set at login; defaults to customer if missing. */
export function getRole() {
  const r = localStorage.getItem(ROLE_KEY);
  if (r === "superadmin") return "superadmin";
  if (r === "admin") return "admin";
  return "customer";
}

export function setRole(role) {
  if (role === "superadmin") {
    localStorage.setItem(ROLE_KEY, "superadmin");
  } else if (role === "admin") {
    localStorage.setItem(ROLE_KEY, "admin");
  } else {
    localStorage.setItem(ROLE_KEY, "customer");
  }
}

export function isAuthenticated() {
  const t = getToken();
  return typeof t === "string" && t.length > 0;
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
}

/** For axios: `{ headers: getAuthHeaders() }` */
export function getAuthHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
